import { render, staticRenderFns } from "./u8.helper.box.vue?vue&type=template&id=5711ba22&"
import script from "./u8.helper.box.vue?vue&type=script&lang=js&"
export * from "./u8.helper.box.vue?vue&type=script&lang=js&"
import style0 from "./u8.helper.box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/ug-quartz-client-prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5711ba22')) {
      api.createRecord('5711ba22', component.options)
    } else {
      api.reload('5711ba22', component.options)
    }
    module.hot.accept("./u8.helper.box.vue?vue&type=template&id=5711ba22&", function () {
      api.rerender('5711ba22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/u8sdk/components/u8.helper.box.vue"
export default component.exports